import {
    Component
} from '@angular/core';
import {
    AbstractModalBase
} from '@lmnop/angular-core';
import {
    IoCContainer
} from '@lmnop/web-core';
import {
    IAppSettings,
    AppIoCKeys,
    IAppIoCContainer
} from 'app-src';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    template: '',
    selector: 'app-modal-base',
})
export abstract class ModalBase extends AbstractModalBase {

    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
        this.ioc = IoCContainer.get(AppIoCKeys.IAppIoCContainer);
        this.settings = this.ioc.settings;
    }

    protected ioc: IAppIoCContainer;
    protected settings: IAppSettings;

}
